import { Wifi, Bot, Briefcase } from "lucide-react";
import { cn } from "@/lib/utils";
import { useMyAgents, useMyJobs } from "@/hooks/use-queries";

export function NetworkStatus({ className }: { className?: string }) {
  const { data: agents } = useMyAgents();
  const { data: jobs } = useMyJobs();

  return (
    <div className={cn("flex items-center gap-3", className)}>
      {/* Agents Count */}
      <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background/50 border border-border/40 backdrop-blur-sm">
        <Bot className="h-3 w-3 text-primary/70" />
        <span className="text-[10px] font-mono font-bold text-foreground/80">
          {agents?.length || 0}
        </span>
        <span className="text-[8px] font-mono text-muted-foreground/50 uppercase tracking-tighter">Agents</span>
      </div>

      {/* Jobs Count */}
      <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background/50 border border-border/40 backdrop-blur-sm">
        <Briefcase className="h-3 w-3 text-primary/70" />
        <span className="text-[10px] font-mono font-bold text-foreground/80">
          {jobs?.data?.length || 0}
        </span>
        <span className="text-[8px] font-mono text-muted-foreground/50 uppercase tracking-tighter">Posted</span>
      </div>

      {/* Compressed System Online */}
      <div className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-background/50 border border-border/40 backdrop-blur-sm">
        <div className="relative flex h-1.5 w-1.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-green-500"></span>
        </div>
        <span className="text-[9px] font-mono uppercase tracking-widest text-muted-foreground font-bold">
          SYS
        </span>
      </div>
    </div>
  );
}
